import { render, staticRenderFns } from "./mainsurvey.vue?vue&type=template&id=f77e9648&scoped=true&"
import script from "./mainsurvey.vue?vue&type=script&lang=js&"
export * from "./mainsurvey.vue?vue&type=script&lang=js&"
import style0 from "./mainsurvey.vue?vue&type=style&index=0&id=f77e9648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77e9648",
  null
  
)

export default component.exports